export const RESET_STATE = `RESET_STATE`;
export const ADD_ROW = `ADD_ROW`;
export const ERROR = `ERROR`;
export const SUCCESS = `SUCCESS`;
export const TOGGLE_LOADING = `TOGGLE_LOADING`;
export const SET_META = `SET_META`;
export const CONCAT_LIST = `CONCAT_LIST`;
export const SET_LIST = `SET_LIST`;
export const SET_ALL = `SET_ALL`;
export const RESET = `RESET`;
export const UPDATE_LIST_ITEM = `UPDATE_LIST_ITEM`;
export const REMOVE_LIST_ITEM = `REMOVE_LIST_ITEM`;
export const UPDATE_USER_FORM_ACCES = `UPDATE_USER_FORM_ACCES`;
export const SET_AXIOS_CALL = `SET_AXIOS_CALL`;
export const UPDATE_USER_DRAWER = `UPDATE_USER_DRAWER`;
export const UPDATE_DRAWER = `UPDATE_DRAWER`;
export const DROP_SNACKBAR = `DROP_SNACKBAR`;
export const SET_NOTIFICATION_BADGE = `SET_NOTIFICATION_BADGE`;
export const SET_DESTINATION_ROUTERNAME = `SET_DESTINATION_ROUTERNAME`;
export const SET_DESTINATION_ROUTERPARAMS = `SET_DESTINATION_ROUTERPARAMS`;
